var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/** @jsx jsx */


import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import { Children, forwardRef, Fragment, memo, useImperativeHandle } from "react";
import { jsx } from "theme-ui";
import useTheme from "../useTheme";
import Arrow from "./Arrow";
export var getBreakpoints = function getBreakpoints(theme) {
  var breakpoints = {};

  if (Array.isArray(theme.breakpoints)) {
    theme.breakpoints.forEach(function (breakpoint) {
      breakpoints["(min-width:" + String(breakpoint) + ")"] = {};
    });
  }

  return breakpoints;
};

var CarouselComponent = function CarouselComponent(_a, ref) {
  var children = _a.children,
      _b = _a.initial,
      initial = _b === void 0 ? 0 : _b,
      _c = _a.slidesPerView,
      slidesPerView = _c === void 0 ? 4 : _c,
      spacing = _a.spacing,
      _mounted = _a.mounted,
      _d = _a.arrowType,
      arrowType = _d === void 0 ? "chevron" : _d,
      _e = _a.arrowPosition,
      arrowPosition = _e === void 0 ? "inside" : _e,
      props = __rest(_a, ["children", "initial", "slidesPerView", "spacing", "mounted", "arrowType", "arrowPosition"]);

  var theme = useTheme().theme;
  var resolvedSpacing = spacing ? parseInt(theme.space[spacing]) : 0;

  var _f = useKeenSlider(__assign({
    slidesPerView: slidesPerView,
    spacing: resolvedSpacing,
    initial: initial,
    mounted: function mounted(instance) {
      if (_mounted) {
        _mounted(instance);
      }
    }
  }, props)),
      sliderRef = _f[0],
      slider = _f[1];

  useImperativeHandle(ref, function () {
    return slider;
  }, [slider]);
  var arrowSx = {
    position: "absolute"
  };

  if (arrowPosition === "inside") {
    arrowSx = __assign(__assign({}, arrowSx), {
      top: "50%",
      transform: "translateY(-50%)"
    });
  }

  if (arrowPosition === "outside") {
    arrowSx = __assign(__assign({}, arrowSx), {
      top: 0,
      bottom: 0
    });
  }

  var slideCount = typeof slidesPerView === "number" ? slidesPerView : slidesPerView();
  var slideRatio = 100 / slideCount;
  var slideSpacing = resolvedSpacing / slideCount * (slideCount - 1); // Emulating keen slider style property

  var slideStyle = {
    minWidth: "calc(" + slideRatio + "% - " + slideSpacing + "px)",
    maxWidth: "calc(" + slideRatio + "% - " + slideSpacing + "px)",
    transform: "translate3d(0px, 0px, 0px)"
  };
  return jsx("div", {
    sx: {
      position: "relative"
    }
  }, jsx("div", {
    ref: sliderRef,
    className: "keen-slider",
    sx: {
      marginLeft: arrowPosition === "outside" ? "32px" : undefined,
      marginRight: arrowPosition === "outside" ? "32px" : undefined
    }
  }, Children.toArray(children).map(function (child, index) {
    return jsx("div", {
      key: index,
      className: "keen-slider__slide",
      style: slideStyle
    }, child);
  })), slider && arrowType && jsx(Fragment, null, jsx("div", {
    sx: __assign(__assign({}, arrowSx), {
      left: arrowPosition === "outside" ? 0 : 3
    })
  }, jsx(Arrow, {
    arrowType: arrowType,
    arrowPosition: arrowPosition,
    direction: "previous",
    onClick: function onClick(event) {
      event.stopPropagation();
      slider.prev();
    }
  })), jsx("div", {
    sx: __assign(__assign({}, arrowSx), {
      right: arrowPosition === "outside" ? 0 : 3
    })
  }, jsx(Arrow, {
    arrowType: arrowType,
    arrowPosition: arrowPosition,
    direction: "next",
    onClick: function onClick(event) {
      event.stopPropagation();
      slider.next();
    }
  }))));
};

export default memo(forwardRef(CarouselComponent));